import { AxiosError } from "axios";

import { ForbiddenError } from "./ForbiddenError";
import { NotFoundError } from "./NotFoundError";
import { BadRequestError } from "./BadRequestError";
import { ServerError } from "./ServerError";
import { ApiError } from "./BaseApiError";

interface ApiErrorFactory extends AxiosError<any> {}

class ApiErrorFactory {
  public create(error: AxiosError<any>): ApiError | undefined {
    const statusCode: number | undefined = error?.response?.status;
    switch (statusCode) {
      case 403:
        return new ForbiddenError(error);
      case 404:
        return new NotFoundError(error);
      case 400:
        return new BadRequestError(error);
      case 500 || 408:
        return new ServerError(error);
      default:
        return undefined;
    }
  }
}

const apiErrorFactory = new ApiErrorFactory();
export default apiErrorFactory;
